import React from 'react';

import ReactTable from '../react-table';
import Pagination from './Pagination';

import style from './Table.scss';

const Table = React.memo(props => {
  const { pageSizeOptions } = props;

  const defaultOptions = {
    defaultPageSize: 10,
    pageSizeOptions:
      pageSizeOptions && pageSizeOptions.length > 1
        ? pageSizeOptions
        : [5, 10, 25, 50, -1],
    loadingText: (
      <div className="spinner">
        <div className="bounce1" />
        <div className="bounce2" />
        <div className="bounce3" />
      </div>
    ),
    resizable: false,
    filterable: false,
    noDataText: `No ${props.entityNameText ||
      'rows'} match search and filter criteria.`,
    PaginationComponent: Pagination,
  };

  const calcWidth = (records, column) => {
    const { accessor, Header: headerText } = column;
    let max = 0;
    const magicSpacing = 9;

    for (let i = 0; i < records.length; i += 1) {
      if (records[i] !== undefined && records[i][accessor] !== null) {
        if (JSON.stringify(records[i][accessor] || 'null').length > max) {
          max = JSON.stringify(records[i][accessor] || 'null').length;
        }
      }
    }

    const width = Math.max(max, headerText.length) * magicSpacing;

    return width;
  };

  const autoWidthColumns = props.columns.filter(c => c.width === 'auto');
  for (let i = 0; i < autoWidthColumns.length; i += 1) {
    const column = autoWidthColumns[i];

    const autoWidth = calcWidth(props.data, column);
    column.width = Math.min(
      Math.max(autoWidth, column.minWidth || 0),
      column.maxWidth || Infinity,
    );
  }

  const options = { ...defaultOptions, ...props, columns: props.columns };

  return <ReactTable {...options} style={style} minRows />;
});

export default Table;
